import React, { useState, useEffect } from 'react';
import { IoIosArrowBack } from 'react-icons/io';
import { IoCheckmark } from 'react-icons/io5';
import Spinner from 'react-bootstrap/Spinner';
import { fetchWithAuth } from './authService';
import { API_ENDPOINTS } from '../utils/constants';

const ShoutOutOptions = () => {
  const [searchResults, setSearchResults] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedMessage, setSelectedMessage] = useState(
    localStorage.getItem('selectedMessage') || 'Happy Birthday'
  );

  useEffect(() => {
    const fetchOccasions = async () => {
      setIsLoading(true);
      try {
        const response = await fetchWithAuth(API_ENDPOINTS.SHOUTOUT_MESSAGES, {
          method: 'GET',
          headers: { 'Content-Type': 'application/json' },
        });

        if (!response.ok) throw new Error('Failed to fetch occasions');

        const data = await response.json();
        setSearchResults(data);
        // Set default if not already selected
        if (!localStorage.getItem('selectedMessage')) {
          localStorage.setItem('selectedMessage', 'Happy Birthday');
          setSelectedMessage('Happy Birthday');
        }
      } catch (error) {
        console.error('Error fetching occasions:', error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchOccasions();
  }, []);

  const goBack = () => window.history.back();

  const select = option => {
    localStorage.setItem('selectedMessage', option.message);
    localStorage.setItem('selectedThumbnail', option.thumbnail);
    setSelectedMessage(option.message);
    window.history.back();
  };

  return (
    <div
      className="px-2 my-0 py-0 d-flex flex-column align-items-center position-relative text-black"
      style={{ height: '100dvh' }}
    >
      {isLoading && (
        <div className="lmodale">
          <div className="loverlay"></div>
          <div className="lmodalecontent">
            <Spinner animation="border" role="status" style={{ color: 'red' }}>
              <span className="visually-hidden">Loading...</span>
            </Spinner>
          </div>
        </div>
      )}

      {/* Header */}
      <div
        className="position-sticky w-100"
        style={{ top: 0, backgroundColor: '#FFF', zIndex: 1 }}
      >
        <div
          className="d-flex align-items-center justify-content-between px-3 mt-2"
          style={{ height: '48px' }}
        >
          {/* Back Arrow */}
          <IoIosArrowBack
            style={{
              fontSize: '20px',
              cursor: 'pointer',
              color: '#D0151C',
            }}
            onClick={goBack}
          />

          {/* Title */}
          <span
            style={{
              fontSize: 'clamp(0px, 7dvw, 20px)',
              background: '#D0151C',
              backgroundClip: 'text',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              fontWeight: '600',
            }}
          >
            Select Occasion
          </span>

          {/* Empty right space */}
          <div style={{ width: '20px' }}></div>
        </div>
      </div>

      {/* Options */}
      <div
        className="w-100 d-flex flex-column position-relative"
        style={{ overflow: 'scroll', flexGrow: 1 }}
      >
        <div className="w-100 mt-2">
          {searchResults.length === 0 ? (
            <div className="text-center mt-4">No messages found.</div>
          ) : (
            searchResults.map((item, index) => {
              const isSelected = item.message === selectedMessage;
              return (
                <div
                  className="d-flex justify-content-between align-items-center px-3 py-2"
                  key={index}
                  onClick={() => select(item)}
                  style={{ cursor: 'pointer' }}
                >
                  {/* Thumbnail + Occasion Text */}
                  <div className="d-flex align-items-center">
                    <img
                      src={item.thumbnail}
                      alt={item.message}
                      style={{
                        width: '32px',
                        height: '32px',
                        objectFit: 'cover',
                        marginRight: '10px',
                      }}
                    />
                    <span
                      style={{
                        fontSize: '16px',
                        fontWeight: isSelected ? '600' : '350',
                        background: isSelected ? '#D0151C' : 'none',
                        WebkitBackgroundClip: isSelected ? 'text' : 'none',
                        WebkitTextFillColor: isSelected
                          ? 'transparent'
                          : 'black',
                      }}
                    >
                      {item.message}
                    </span>
                  </div>

                  {/* Checkmark */}
                  {isSelected && (
                    <IoCheckmark
                      style={{
                        fontSize: '18px',
                        color: '#D0151C',
                      }}
                    />
                  )}
                </div>
              );
            })
          )}
        </div>
      </div>
    </div>
  );
};

export default ShoutOutOptions;
